import axios from 'axios';
//import HCaptcha from '@hcaptcha/react-hcaptcha';
import BackIcon from 'imagesUwKluis/svg/back.svg';
import Button from '../../shared/Button';
import DateInputs from '../../shared/Date';
import Input from '../../shared/Input';
import { Box, Stack, WithIcon } from '../../shared/layouts';
import Labeled from '../../shared/WithLabel';
import Container from './LoginContainer';
import { useTranslation } from 'react-i18next';
import useForm from '../../../hooks/useForm';
import { useContext, useState } from 'react';
import WhiteLabelContext from '../../../context/WhiteLabelContext';
//import i18n from '../../../i18n';
import { Link, useNavigate } from 'react-router-dom';

const RequestInvite = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [message, setMessage] = useState();
  const { /*hCaptchaSiteKay,*/ canRequestInvite} = useContext(WhiteLabelContext);
  //const captchaRef = useRef();
  const [errors, setErrors] = useState({});
  const [state, handleState] = useForm({
    email: '',
    phone_number: '',
    first_name: '',
    addition: '',
    last_name: '',
    date_of_birth: '',
  });

  /*const handleChalExpired = () => {
    captchaRef.current.resetCaptcha();
    setCaptchaToken(null);
  };*/

  if (canRequestInvite !== undefined && canRequestInvite !== true) {
    navigate('/not-found');
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post('/request-invite', { ...state /*, ...{ captcha_token: captchaToken }*/ })
      .then(() => {
        setMessage(
          'Account is succesvol aangemaakt. Hou je mailbox in de gaten voor de mail met verdere instucties. Neem contact met ons op als je deze mail niet binnen een dag hebt ontvangen.'
        );
      })
      .catch((err) => {
        const response = err.response;

        if (response.status === 422) {
          setErrors(response.data.errors);
        } else {
          setMessage(
            'Er is iets fout gegaan. Probeer het opnieuw of neem contact op indien het fout blijft gaan.'
          );
        }
      });
  };

  return (
    <Container handleSubmit={handleSubmit}>
      <Link
        id="goBack"
        to="/login"
        css={(theme) => ({
          fontSize: theme.fontSizes.m,
          marginTop: '8px',
          textDecoration: 'underline',
          color: theme.colors.secondaryButtonHover,
          fontWeight: 'bold',
        })}
      >
        <WithIcon space="none" color="secondaryButtonHover">
          <BackIcon width="1.5rem" height="1.5rem" />
          {t('Terug')}
        </WithIcon>
      </Link>

      {message ? (
        <Box>{t(message)}</Box>
      ) : (
        <>
          <Box fontScale="2xl" fontWeight="bold">
            {t('Account aanmaken')}
          </Box>
          <Stack space="m">
            <Labeled label={t('E-mailadres')}>
              <Input
                name="email"
                value={state.email}
                onChange={handleState}
                errors={errors?.email}
              />
            </Labeled>
            <Labeled label={t('Telefoonnummer')}>
              <Input
                name="phone_number"
                value={state.phone_number}
                onChange={handleState}
                errors={errors?.phone_number}
              />
            </Labeled>
            <Labeled label={t('Voornaam')}>
              <Input
                name="first_name"
                value={state.first_name}
                onChange={handleState}
                errors={errors?.first_name}
              />
            </Labeled>
            <Labeled label={t('Tussenvoegsel')}>
              <Input
                name="addition"
                value={state.addition}
                onChange={handleState}
              />
            </Labeled>
            <Labeled label={t('Achternaam')}>
              <Input
                name="last_name"
                value={state.last_name}
                onChange={handleState}
                errors={errors?.last_name}
              />
            </Labeled>
            <Labeled label={t('Geboortedatum')}>
              <DateInputs
                name="date_of_birth"
                value={state.date_of_birth}
                onChange={handleState}
                errors={errors?.date_of_birth}
              />
            </Labeled>
            {/*hCaptchaSiteKay && (
              <HCaptcha
                ref={captchaRef}
                sitekey={hCaptchaSiteKay}
                onVerify={(token) => setCaptchaToken(token)}
                onChalExpired={handleChalExpired}
                languageOverride={i18n.language}
              />
            )*/}
            <Button
              type="submit"
              variant="primary"
              width="100%"
            >
              {t('Aanmaken')}
            </Button>
          </Stack>
        </>
      )}
    </Container>
  );
};

export default RequestInvite;
